export const ADMIN_PERMISSIONS = {
  DASHBOARD_VIEW: 'admin.dashboard.view',
  USERS_VIEW: 'admin.users.view',
  USERS_EXPORT_CSV: 'admin.users.export.csv',
  USERS_EXPORT_XLSX: 'admin.users.export.xlsx',
  CATALOG_VIEW: 'admin.catalog.view',
  CATALOG_CREATE: 'admin.catalog.create',
  CATALOG_UPDATE: 'admin.catalog.update',
  CATALOG_DELETE: 'admin.catalog.delete',
  CATALOG_REORDER: 'admin.catalog.reorder',
  PROMOCODES_VIEW: 'admin.promocodes.view',
  PROMOCODES_CREATE: 'admin.promocodes.create',
  PROMOCODES_UPDATE: 'admin.promocodes.update',
  PROMOCODES_DELETE: 'admin.promocodes.delete',
  MARKETING_VIEW: 'admin.marketing.view',
  EXPORT_VIEW: 'admin.export.view',
  EXPORT_CSV: 'admin.export.csv',
  EXPORT_XLSX: 'admin.export.xlsx',
  FORECAST_VIEW: 'admin.forecast.view',
  AUDIT_VIEW: 'admin.audit.view',
  SETTINGS_VIEW: 'admin.settings.view',
} as const;

export type AdminPermission = (typeof ADMIN_PERMISSIONS)[keyof typeof ADMIN_PERMISSIONS];
